import React from 'react';

import { css } from 'glamor';

export default (props = {}) => (
  <svg { ...css({display: 'block', width: props.width || 38, height: props.height || 55 })} xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 22">
    <defs>
      <filter id="a" width="116.7%" height="116.7%" x="-8.3%" y="-4.2%" filterUnits="objectBoundingBox">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5"/>
        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    <g fill="#FFF" fillRule="nonzero" filter="url(#a)" transform="translate(1 -2)">
      <path d="M1.663 16.612c-.445 0-.806-.342-.806-.765V8.152c0-.422.36-.765.806-.765h3.57l7.013-4.676a.843.843 0 0 1 .835-.054.76.76 0 0 1 .435.679v17.328a.76.76 0 0 1-.433.678.843.843 0 0 1-.834-.052l-7.016-4.678h-3.57zM23.254 8.593a.84.84 0 0 0-1.184 0L19.5 11.15l-2.568-2.558a.84.84 0 0 0-1.186-.001.832.832 0 0 0-.001 1.18l2.569 2.559-2.57 2.558a.832.832 0 0 0 .021 1.159.84.84 0 0 0 1.164.02l2.569-2.558 2.569 2.558a.84.84 0 0 0 1.163-.02.832.832 0 0 0 .02-1.159l-2.563-2.558 2.57-2.559a.832.832 0 0 0-.003-1.18z"/>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ../src/client/components/icons/VideoVolumeOff.js